module.exports = __webpack_public_path__ + "img/merchantcenter-blog.dummycover.ee6a1b44.png";